import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { FormattedMessage } from 'react-intl';
import Menu from '../Menu';
import Divider from '../Divider';
import Icon from '../Icon';
import RepVisitsPendingCounter from '../RepVisitsPendingCounter';
import FeatureEnabled from '../FeatureEnabled';
import { REPVISITS_RSVP_COUNTER } from '../../containers/Authorization/constants';
import { active } from './styles.css';

function getEventTabActiveClass(router, path) {
  return router.location.pathname.includes(path) ? 'navActive' : '';
}

const NotificationsMenu = (props) => (
  <nav aria-label="RepVisits Notifications Menu">
    <Menu className={props.className} stackable as="ul" pointing secondary size="huge" styleName="navMenu">
      <Menu.Header styleName="navMenu-header">
        <span styleName="align-header-left">
          <Icon
            styleName="backToNotifications"
            onClick={props.toggleSecondaryMenu}
            name="angle left"
            size="big"
          />
        </span>
        <span styleName="notificationsHeader">NOTIFICATIONS</span>
        <span styleName="align-header-right">
          <Icon
            styleName="closeIcon"
            onClick={props.toggleVisibility}
            name="x"
            aria-hidden="true"
            size="large"
          />
        </span>
      </Menu.Header>
      <Divider styleName="menu-divider" />
      <Menu.Item as="li" link styleName={`navMenu-item ${getEventTabActiveClass(props.router, '/rep-visits/notifications/requests')}`}>
        <Link
          activeClassName={active}
          to="/rep-visits/notifications/requests"
          styleName="navMenu-link"
          onClick={props.toggleVisibility}
        >
          <div styleName="menu-item-content">
            <FormattedMessage id="repvisits.notifications.menu.request" defaultMessage="Requests" />
            <FeatureEnabled allOf={[REPVISITS_RSVP_COUNTER]}>
              <RepVisitsPendingCounter />
            </FeatureEnabled>
          </div>
        </Link>
      </Menu.Item>
      <Divider styleName="menu-divider" />
      <Menu.Item as="li" link styleName={`navMenu-item ${getEventTabActiveClass(props.router, '/rep-visits/notifications/activity')}`}>
        <Link
          activeClassName={active}
          to="/rep-visits/notifications/activity"
          styleName="navMenu-link"
          onClick={props.toggleVisibility}
        >
          <FormattedMessage id="repvisits.notifications.menu.activity" defaultMessage="Activity" />
        </Link>
      </Menu.Item>
      <Divider styleName="menu-divider" />
      <Menu.Item
        as="li"
        link
        styleName={`navMenu-item ${getEventTabActiveClass(props.router, '/rep-visits/notifications/hsavailable')}`}
      >
        <Link
          activeClassName={active}
          to="/rep-visits/notifications/hsavailable"
          styleName="navMenu-link"
          onClick={props.toggleVisibility}
        >
          <FormattedMessage id="repvisits.notifications.menu.hsavailable" defaultMessage="High Schools Now Available" />
        </Link>
      </Menu.Item>
    </Menu>
  </nav>
);

NotificationsMenu.propTypes = {
  toggleVisibility: PropTypes.func.isRequired,
  toggleSecondaryMenu: PropTypes.func.isRequired,
  className: PropTypes.string,
  router: PropTypes.shape({
    location: PropTypes.object.isRequired,
  }).isRequired,
};

export default NotificationsMenu;
